import(/* webpackMode: "eager" */ "/vercel/path0/app/forget-password/page.js");
